import React from 'react';
import cx from 'classnames';

import SectionHeading from '../SectionHeading/SectionHeading';

import BenefitCard from './BenefitCard';
import type { BenefitCardsProps } from './BenefitCards.types';

import styles from './BenefitCards.module.scss';

const BenefitCards: React.FC<BenefitCardsProps> = ({ cards, className, heading, preheading }) => (
	<section className={cx(styles.wrapper, className)}>
		<SectionHeading heading={heading} preheading={preheading} />
		<div className={styles.cards}>
			{cards.map((benefit) => (
				<BenefitCard key={benefit.id} {...benefit} />
			))}
		</div>
	</section>
);

export default BenefitCards;
